import { SVGProps } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { ChannelIcon, ChartLineIcon, FaceFillIcon, PlusIcon, ScreenArrowupFillIcon } from '@zep/icons';
import { Accordion, AccordionButton, AccordionPanel, Button, Spacing } from '@zep/ui';
import { getGeoInfoFromTimeZone, isMobileDevice } from '@zep/utils';
import { PricingCardProps } from '../../types';
import { PricingCard } from '../PricingCard';
import { FeatureListItem } from './shared';
export const EnterprisePlanCard = (props: PricingCardProps) => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    locale
  } = useRouter();
  return <PricingCard.Root data-sentry-element="unknown" data-sentry-component="EnterprisePlanCard" data-sentry-source-file="EnterprisePlanCard.tsx">
      <PricingCard.Header data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
        <div className="flex">
          <div className="flex w-full flex-col">
            <PricingCard.Title data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">Enterprise</PricingCard.Title>
            <PricingCard.TitleDescription data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
              {t('subscription:pricing.enterprise.description', '대규모 행사에 서포트 필요하다면')}
            </PricingCard.TitleDescription>
          </div>
          <PricingCard.Logo data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
            <MessageGradientSvg data-sentry-element="MessageGradientSvg" data-sentry-source-file="EnterprisePlanCard.tsx" />
          </PricingCard.Logo>
        </div>
      </PricingCard.Header>
      <PricingCard.Content data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
        <Spacing size={62} data-sentry-element="Spacing" data-sentry-source-file="EnterprisePlanCard.tsx" />
        <Spacing size={8} data-sentry-element="Spacing" data-sentry-source-file="EnterprisePlanCard.tsx" />
        <Button isFullWidth className="!bg-[#27262ECC] hover:!bg-gray-900" onClick={props.onClickCardButton} data-sentry-element="Button" data-sentry-source-file="EnterprisePlanCard.tsx">
          {t('subscription:pricing.plansEnterprise.buttonContact', '도입 문의')}
        </Button>
        {locale === 'ko' && <Spacing size={27} />}
      </PricingCard.Content>
      <PricingCard.Footer data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
        {isMobileDevice() ? <Accordion className="!border-none !bg-white">
            <AccordionButton className="text-body-1-sb justify-between !p-0 !text-[14px] font-[600] text-gray-900">
              {t('subscription:pricing.mainFeatures', '주요 기능')}
            </AccordionButton>
            <AccordionPanel className="!p-0">
              <Spacing size={16} />
              <FooterContent />
              <Spacing size={14} />
            </AccordionPanel>
          </Accordion> : <FooterContent />}
      </PricingCard.Footer>
    </PricingCard.Root>;
};
const FooterContent = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const isLocaleJapanese = (() => {
    const {
      city
    } = getGeoInfoFromTimeZone();
    return city === 'Tokyo';
  })();
  return <div className="flex flex-col" data-sentry-component="FooterContent" data-sentry-source-file="EnterprisePlanCard.tsx">
      <PricingCard.FeatureTitle data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
        {t('subscription:pricing.enterprise.feature1', 'Pro의 모든 기능+')}
      </PricingCard.FeatureTitle>
      <Spacing size={16} data-sentry-element="Spacing" data-sentry-source-file="EnterprisePlanCard.tsx" />
      <FeatureListItem.Root data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
        {isLocaleJapanese && <FeatureListItem.List>
            <FeatureListItem.Icon>
              <ChartLineIcon width={16} height={16} fill={'#27262ECC'} />
            </FeatureListItem.Icon>
            <FeatureListItem.Text>
              {t('subscription:pricing.enterprise.feature2', '데이터 대시보드 제공')}
            </FeatureListItem.Text>
          </FeatureListItem.List>}
        <FeatureListItem.List data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
          <FeatureListItem.Icon data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
            <ScreenArrowupFillIcon width={16} height={16} fill={'#27262ECC'} data-sentry-element="ScreenArrowupFillIcon" data-sentry-source-file="EnterprisePlanCard.tsx" />
          </FeatureListItem.Icon>
          <FeatureListItem.Text data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
            {t('subscription:pricing.enterprise.feature3', '엔터프라이즈 전용 서버 할당')}
          </FeatureListItem.Text>
        </FeatureListItem.List>
        <FeatureListItem.List data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
          <FeatureListItem.Icon data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
            <FaceFillIcon width={16} height={16} fill={'#27262ECC'} data-sentry-element="FaceFillIcon" data-sentry-source-file="EnterprisePlanCard.tsx" />
          </FeatureListItem.Icon>
          <FeatureListItem.Text data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
            {t('subscription:pricing.enterprise.feature4', '전담 매니저 할당')}
          </FeatureListItem.Text>
        </FeatureListItem.List>
        <FeatureListItem.List data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
          <FeatureListItem.Icon data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
            <ChannelIcon width={16} height={16} fill={'#27262ECC'} data-sentry-element="ChannelIcon" data-sentry-source-file="EnterprisePlanCard.tsx" />
          </FeatureListItem.Icon>
          <FeatureListItem.Text data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
            {t('subscription:pricing.enterprise.feature5', '채널링 조정')}
          </FeatureListItem.Text>
        </FeatureListItem.List>
        <FeatureListItem.List data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
          <FeatureListItem.Icon data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
            <PlusIcon width={16} height={16} fill={'#27262ECC'} data-sentry-element="PlusIcon" data-sentry-source-file="EnterprisePlanCard.tsx" />
          </FeatureListItem.Icon>
          <FeatureListItem.Text data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
            {t('subscription:pricing.enterprise.feature6', '이외의 전용 기능 협의를 통해 선택')}
          </FeatureListItem.Text>
        </FeatureListItem.List>
      </FeatureListItem.Root>
    </div>;
};
const MessageGradientSvg = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={28} height={28} fill="none" {...props} data-sentry-element="svg" data-sentry-component="MessageGradientSvg" data-sentry-source-file="EnterprisePlanCard.tsx">
    <path fill="url(#message-from)" fillRule="evenodd" d="M4.666 4.667A2.333 2.333 0 0 0 2.333 7v12.833a2.333 2.333 0 0 0 2.333 2.334h5.35l3.159 3.158a1.167 1.167 0 0 0 1.65 0l3.158-3.158h5.35a2.333 2.333 0 0 0 2.333-2.334V7a2.333 2.333 0 0 0-2.333-2.333H4.666Zm3.5 5.25a1.167 1.167 0 0 0 0 2.333h11.667a1.167 1.167 0 0 0 0-2.333H8.166Zm0 4.666a1.167 1.167 0 1 0 0 2.334h7a1.167 1.167 0 1 0 0-2.334h-7Z" clipRule="evenodd" data-sentry-element="path" data-sentry-source-file="EnterprisePlanCard.tsx" />
    <defs data-sentry-element="defs" data-sentry-source-file="EnterprisePlanCard.tsx">
      <linearGradient id="message-from" x1={14} x2={14} y1={4.667} y2={25.667} gradientUnits="userSpaceOnUse" data-sentry-element="linearGradient" data-sentry-source-file="EnterprisePlanCard.tsx">
        <stop stopColor="#27262E" data-sentry-element="stop" data-sentry-source-file="EnterprisePlanCard.tsx" />
        <stop offset={1} stopColor="#949CBD" data-sentry-element="stop" data-sentry-source-file="EnterprisePlanCard.tsx" />
      </linearGradient>
    </defs>
  </svg>;